export const GET_TICKETS_REQUEST = "GET_TICKETS_REQUEST";
export const GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS";
export const GET_VENDOR_LIST_REQUEST = "GET_VENDOR_LIST_REQUEST";
export const GET_VENDOR_LIST_SUCCESS = "GET_VENDOR_LIST_SUCCESS";
export const CREATE_SUPPORT_REQUEST = "CREATE_SUPPORT_REQUEST";
export const CREATE_SUPPORT_SUCCESS = "CREATE_SUPPORT_SUCCESS";
export const GET_SUPPORT_VENDOR_REQUEST = "GET_SUPPORT_VENDOR_REQUEST";
export const GET_SUPPORT_VENDOR_SUCCESS = "GET_SUPPORT_VENDOR_SUCCESS";